function adjustFixedHeaderForAdminBar() {
  const header = document.querySelector('.gb-site-header');
  const body = document.body;

  if (!header) return;

  const isFixed = getComputedStyle(header).position === 'fixed';
  const hasAdminBar = body.classList.contains('admin-bar');
  const isLoggedIn = body.classList.contains('logged-in');

  if (isFixed && hasAdminBar && isLoggedIn) {
    header.style.top = '32px';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', adjustFixedHeaderForAdminBar);
} else {
  adjustFixedHeaderForAdminBar();
}
